<template>
  <!-- eslint-disable -->
<v-container fluid class="admin-users-vue">
<v-slide-y-transition mode="out-in">
    <div>
        <v-dialog v-model="loader" persistent fullscreen content-class="loading-dialog">
          <v-container fill-height>
            <v-layout row justify-center align-center>
              <v-progress-circular indeterminate :size="70" :width="7" color="blue"></v-progress-circular>
            </v-layout>
          </v-container>
        </v-dialog>

        <div v-if="!loader">
            <v-dialog v-if="selectedUser" v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition" scrollable>
                <v-card tile>
                    <v-app-bar flat dark color="primary">
                        <v-btn icon class="close-btn" dark @click.native="dialog = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                        <v-toolbar-title>{{selectedUser.GivenName}} {{selectedUser.Surname}}</v-toolbar-title>
                    </v-app-bar>
                    <v-card-text>
                        <h2>{{selectedUser.UserPrincipalName}}</h2>
                        <h3>Groups</h3>
                        <template v-for="g in selectedUser.Groups">
                            <v-switch :label="g.DisplayName" v-model="g.IsAssigned" class="group-toggle" :key="g.id" @change="toggleGroup(g)"></v-switch>
                            <div :key="g.id">{{g.Description}}</div>
                        </template>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-text-field style="padding-bottom: 15px;" v-model="search" class="user-filter" append-icon="search" label="Search" single-line hide-details></v-text-field>
            <v-data-table class="user-list" disable-pagination hide-default-footer :items="users" :loading="loading" :search="search" :headers="headers" :mobile-breakpoint="0">
              <template v-slot:item="{ item }">
                  <tr class="user">
                      <td>
                          <v-btn class="edit-btn" @click="getDetails(item)" icon>
                              <v-icon>edit</v-icon>
                          </v-btn>
                          {{item.GivenName}} {{item.Surname}}
                      </td>
                      <td>
                          {{item.UserPrincipalName}}
                      </td>
                  </tr>
              </template>
            </v-data-table>
        </div>
    </div>
    </v-slide-y-transition>
  </v-container>
<!-- eslint-enable -->
</template>
<script>
import { mapGetters } from "vuex";
import userModule, { NAMESPACE } from "./store/userStore";

export default {
  name: "Users",
  data() {
    return {
      dialog: false,
      loader: true,
      search: "",
      headers: [
        {
          text: "Name",
          align: "left",
          sortable: true,
          value: "GivenName"
        },
        {
          text: "Email",
          align: "left",
          sortable: true,
          value: "UserPrincipalName"
        }
      ]
    };
  },
  computed: {
    ...mapGetters(NAMESPACE, ["users", "loading", "selectedUser"])
  },
  created: /* istanbul ignore next */ function() {
    this.$registerVuexModule(NAMESPACE, userModule);
    // ensure the user is in the correct role before serving the content up
    this.$isInRole([this.$roleDefs.ADMIN]).then(res => {
      if (res) this.load();
      else this.$goHome();
    });
  },
  methods: {
    load() {
      this.loader = false;
      return this.$store.dispatch(`${NAMESPACE}/GET`);
    },
    toggleGroup(val) {
      return this.$store.dispatch(`${NAMESPACE}/TOGGLE`, {
        userId: this.selectedUser.Id,
        groupId: val.Id,
        toggleVal: val.IsAssigned
      });
    },
    getDetails(item) {
      return this.$store.dispatch(`${NAMESPACE}/DETAILS`, item.Id).then(res => {
        this.dialog = true;
      });
    }
  }
};
</script>
